export const showAddAdminModal = () => {
    return {
      type: "SHOW_ADD_ADMIN_MODAL",
    };
  };
  
  export const hideAddAdminModal = () => {
    return {
      type: "HIDE_ADD_ADMIN_MODAL",
    };
  };
  